/**
 * High-frequency emoji used in iMessage / WhatsApp / Telegram (Western).
 * Sent as normal utf8mb4 text. Stick to widely supported glyphs (avoid Emoji 13.1+).
 */
export const CHAT_EMOJI_GROUPS = [
  {
    id: 'smileys',
    icon: '😊',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
      '🙂', '😉', '😍', '🥰', '😘', '😗', '😚', '😋', '😛', '😜',
      '😝', '🤑', '🤗', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏',
      '😣', '😥', '😮', '😯', '😪', '😫', '🥱', '😴', '😌', '😒',
      '😓', '😔', '😕', '🙁', '😖', '😞', '😟', '😤', '😢', '😭',
      '😦', '😧', '😨', '😩', '😬', '😰', '😱', '😳', '😵', '😠',
      '😡', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶',
      '🥴', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '🥺', '😈', '👿',
      '💀', '👻', '💩', '🙈', '🙉', '🙊'
    ]
  },
  {
    id: 'gestures',
    icon: '👍',
    emojis: [
      '👋', '🤚', '✋', '🖖', '👌', '✌️', '🤞', '🤟', '🤘', '🤙',
      '👈', '👉', '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛',
      '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪', '💅', '👀'
    ]
  },
  {
    id: 'hearts',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
      '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '💯',
      '🔥', '✨', '⭐', '🌟', '💫', '🎉', '🎊', '🎈', '🏆', '🌹'
    ]
  },
  {
    id: 'symbols',
    icon: '💡',
    emojis: [
      '✅', '❌', '⚠️', '❓', '❗', '💡', '💬', '📌', '📎', '📝',
      '🔒', '🔓', '⏰', '📅', '💰', '💵', '💳', '📈', '📉', '📱',
      '💻', '📧', '📞', '🔔', '☀️', '🌙', '☕', '🍺', '🎂', '🎁'
    ]
  }
]
